import React, { createContext, useContext, useMemo, useState, } from 'react';
/**
 * Analytics-specific context for managing dashboard loading state.
 * This was moved from Redux session slice to reduce global state complexity.
 */
const AnalyticsContext = createContext(undefined);
export const AnalyticsProvider = ({ children }) => {
    const [isLoadingDashboards, setIsLoadingDashboards] = useState(false);
    const value = useMemo(() => ({
        isLoadingDashboards,
        setIsLoadingDashboards,
    }), [isLoadingDashboards]);
    return (<AnalyticsContext.Provider value={value}>
      {children}
    </AnalyticsContext.Provider>);
};
export const useAnalyticsContext = () => {
    const context = useContext(AnalyticsContext);
    if (context === undefined) {
        throw new Error('useAnalyticsContext must be used within an AnalyticsProvider');
    }
    return context;
};
export const useIsLoadingAnalyticsDashboards = () => {
    const { isLoadingDashboards } = useAnalyticsContext();
    return isLoadingDashboards;
};
